@if (!hasClicked) {
  <button
    mat-raised-button
    color="primary"
    (click)="btnClickedHandler()"
    >
    <span>Details</span>
  </button>
}
@if (hasClicked) {
  <div
    class="flex flex-col items-center justify-center flex-grow"
    >
    <mat-spinner [diameter]="20"></mat-spinner>
  </div>
}
